import type { ReactNode } from 'react'
import { ChatProvider } from './ChatProvider'
import { ChatDrawer } from './ChatDrawer'

/** Mount inside authenticated layout. Exposes chat via useChat() for TopBar. */
export function ChatHost({ children }: { children?: ReactNode }) {
  return (
    <ChatProvider>
      {children}
      <ChatDrawer />
    </ChatProvider>
  )
}

export { useChat } from './ChatProvider'
